import React, { useState } from "react";
import { useRazorpay } from "../../../../context/RazorpayContext";
import formatDate from "../../../../common/DateFormate";

const PackageSummaryModal = ({ packageType, currentPlan, refetchBilling }) => {

  const {
    invoiceModalData,
    onClosePackageSummaryModal,
    handleCreatePlan
  } = useRazorpay();

  const [isLoading, setIsLoading] = useState(false);
  if (!invoiceModalData?.isInvoiceDetailsModal) return null;

  const packangeName = packageType === 'upgrade' ? invoiceModalData?.invoiceDetails?.to_package : invoiceModalData?.invoiceDetails?.package_name;
  const planPrice = packageType === 'upgrade' ? invoiceModalData?.invoiceDetails?.total_amount : invoiceModalData?.invoiceDetails?.package_price;
  const billingAmount =
    packageType === "upgrade"
      ? `${invoiceModalData?.invoiceDetails?.prorated_amount} ${invoiceModalData?.invoiceDetails?.currency || 'INR'}`
      : `${invoiceModalData?.invoiceDetails?.invoiceDetailstotal_amount || invoiceModalData?.invoiceDetails?.total_amount} ${invoiceModalData?.invoiceDetails?.currency || invoiceModalData?.currency}`;

  const handleCreatePlanArgument = (e) => {
    handleCreatePlan(
      e,
      setIsLoading,
      packageType,
      currentPlan,
      packageType === 'upgrade' && refetchBilling
    );
  };

  return (
    <>
      <div
        className="modal d-flex align-items-center justify-content-center"
        style={{
          display: "flex",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0, 0, 0, 0.7)",
          backdropFilter: "blur(6px)",
          zIndex: 1052,
          overflowY: "auto", // mobile scroll
          padding: "10px",
        }}
      >
        <div
          className="modal-dialog animate__animated animate__fadeInDown"
          style={{
            maxWidth: "600px",
            width: "100%",
            margin: "0 auto",
          }}
        >
          <div
            className="modal-content border-0 rounded-4 shadow-lg"
            style={{
              background: "linear-gradient(145deg, #ffffff, #f9fafb)",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <div className="modal-header border-0">
              <h4
                className="modal-title fw-bold text-dark"
                style={{ fontSize: "1.2rem" }}
              >
                Your Package Summary
              </h4>
              <div className="modal-close-btn">
                <button type="button" disabled={isLoading} className="btn-close" onClick={onClosePackageSummaryModal}></button>
              </div>
            </div>

            {/* Body */}
            <div className="modal-body p-3 p-md-4">
              <div className="p-3 rounded-4 shadow-sm bg-white">
                <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between mb-3 gap-2">
                  <h5 className="fw-bold text-primary mb-0 d-flex align-items-center flex-wrap">
                    {/* <CreditCard size={20} className="me-2 text-warning" /> */}
                    <i className="bi bi-credit-card text-warning me-2"></i>
                    {packangeName}
                  </h5>
                  {/* <span
                    className="px-3 py-1 rounded-pill text-white plan-detail-card-btn"
                    style={{
                      fontSize: "0.8rem",
                      fontWeight: "600",
                      whiteSpace: "nowrap",
                    }}
                  >
                    🔄 AutoPay Enabled
                  </span> */}
                </div>

                {/* Price */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span className="fw-semibold text-secondary d-flex align-items-center">
                    <i className="bi bi-tag text-success me-2"></i>
                    Package Price
                  </span>
                  <span className="fw-bold text-dark">
                    {planPrice} {invoiceModalData?.invoiceDetails?.currency}
                  </span>
                </div>

                {/* Billing Dates */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="fw-semibold text-secondary d-flex align-items-center">
                    {/* <Calendar size={16} className="me-2 text-info" /> */}
                    <i className="bi bi-calendar3 text-info me-2"></i>
                    Billing Start At
                  </span>
                  <span className="fw-medium text-end">
                    {formatDate(invoiceModalData?.invoiceDetails?.invoiceDetailsbilling_start_at || invoiceModalData?.invoiceDetails?.billing_start_at)}
                  </span>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="fw-semibold text-secondary d-flex align-items-center">
                    {/* <Calendar size={16} className="me-2 text-danger" /> */}
                    <i className="bi bi-calendar3 text-secondary me-2"></i>
                    Billing End At
                  </span>
                  <span className="fw-medium text-end">
                    {formatDate(invoiceModalData?.invoiceDetails?.invoiceDetailsbilling_end_at || invoiceModalData?.invoiceDetails?.billing_end_at)}
                  </span>
                </div>

                <hr />

                {/* Total */}
                <div className="d-flex justify-content-between fs-5 fw-bold text-dark">
                  <span>Billing Amount</span>
                  <span className="text-success">
                    {billingAmount}
                  </span>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div
              className=" border-0 d-flex flex-column flex-sm-row justify-content-between px-3 px-md-4 pb-4"
              style={{ gap: "10px" }}
            >
              <div className="col-md-6 col-12">
              <button
                className="btn btn-light w-100 w-sm-auto px-4 py-2 rounded-3 border shadow-sm"
                onClick={onClosePackageSummaryModal}
                disabled={isLoading}
              >
                Cancel
              </button>
              </div>
              <div className="col-md-6 col-12">
              <button
                className="btn plan-detail-card-btn w-100 w-sm-auto px-4 py-2 fw-semibold rounded-3 shadow"
                onClick={handleCreatePlanArgument}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Processing your request...
                  </>
                ) : <> 🚀 Continue to Payment </>
                }
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PackageSummaryModal;
